import type { AxiosEventBus } from '@shared/axios/axiosEventBus';

import type { ApiConfig } from '@/api/schema/http-client';
import { HttpClient } from '@/api/schema/http-client';

const createHttpClient = <T>(config: ApiConfig<T>, emit: AxiosEventBus['emit']) => {
  const httpClient = new HttpClient<T>(config);

  httpClient.instance.interceptors.response.use(
    (response: unknown) => {
      emit('response', response);
      return response;
    },
    (error: unknown) => {
      emit('responseError', error);
      return Promise.reject(error instanceof Error ? error : new Error(String(error)));
    },
  );
  return httpClient;
};

export default createHttpClient;
